import React, { useEffect } from "react";
import { Provider } from "react-redux";
import { unstable_HistoryRouter as HistoryRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import { QueryClientProvider } from "@tanstack/react-query";
import store, { persistor } from "./store";
import { queryClient } from "./lib/queryClient";
import Theme from "components/template/Theme";
import Layout from "components/layout";
import history from "./history";
import { installStaleChunkRecovery } from "utils/staleChunkRecovery";
import "./locales";

function App() {
  // A release replaces every hashed chunk, so an admin tab left open since
  // before it dies on its next click with "Loading chunk N failed". Reload once
  // to pick up the new release (loop-guarded; see utils/staleChunkRecovery).
  // A lazy PAGE is caught by AppErrorBoundary; this catches the rest.
  useEffect(() => installStaleChunkRecovery(), []);

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <QueryClientProvider client={queryClient}>
          {/* The shared `history` object is what lets a page hold a navigation
              (useUnsavedChangesGuard). BrowserRouter ignores a history prop and
              cannot block. */}
          <HistoryRouter history={history as any}>
            <Theme>
              <Layout />
            </Theme>
          </HistoryRouter>
        </QueryClientProvider>
      </PersistGate>
    </Provider>
  );
}

export default App;
